import { Box } from '@mui/material'
import { alpha } from '@mui/material/styles'

const IconBadge = ({ icon: Icon }) => (
  <Box
    sx={(theme) => ({
      width: 36,
      height: 36,
      flexShrink: 0,
      borderRadius: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'primary.main',
      bgcolor: alpha(theme.palette.primary.main, 0.12),
    })}
  >
    <Icon fontSize="small" />
  </Box>
)

export default IconBadge
